var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('center',[_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/404.jpg"),"width":"45%"}}),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.regresar}},[_vm._v("Ir al Dashboard")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }